import { SalutationType, useGetMeLazyQuery } from "@repo/server-api";
import React, { createContext, useContext, useEffect, useState } from "react";

import type { Contact } from "@repo/server-api";

const emptyContact: Contact = {
	id: "",
	companyName: "",
	contactNumber: "",
	contactTypes: [],
	firstName: "",
	lastName: "",
	additionalInformation: [],
	displayContactType: [],
	displayName: "",
	isACompany: false,
	isAFreelancer: false,
	isAPerson: false,
	isDeleted: false,
	isTemporary: false,
	isContactPerson: false,
	isEmployee: false,
	isAMailbox: false,
	isMemberOf: [],
	version: 0,
	salutation: SalutationType.Mr,
	shortCode: "",
	title: "",
	__typename: "Contact",
};

const MeContext = createContext<Contact>({
	...emptyContact,
});

type MeProviderProps = {
	children: React.ReactNode;
};

export const MeProvider: React.FC<MeProviderProps> = ({ children }) => {
	const [contact, setContact] = useState<Contact>({
		...emptyContact,
	});

	const [getMe] = useGetMeLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data) {
			if (data?.me != null) {
				setContact(data.me as unknown as Contact);
			}
		},
	});

	useEffect(() => {
		void getMe();
	}, [getMe]);

	return <MeContext.Provider value={contact}>{children}</MeContext.Provider>;
};

export const useMe = (): Contact => {
	return useContext(MeContext);
};
